import React, {useState, useRef} from 'react';
import styled from 'styled-components';
import { DiagramView } from '../../../../general_components/content_management/task_list/taskListElements/diagramView';

const StatusContainer = styled.div`
    margin: 0 0.25rem;
    
    .status{
        border-radius: 0.5rem 0.5rem 0 0;
        padding:0.7rem 0.75rem;
        &>div{
            cursor:pointer;
            text-align:center;
            width:9rem;
            padding: 0.5rem 0.4rem;
            background-color:rgba(${props => props.$colorcode ? props.$colorcode : "0, 0, 0"}, 0.2);
            color:rgba(${props => props.$colorcode ? props.$colorcode : "0, 0, 0"}, 0.8);
            font-weight:800;
            border-radius:0.3rem;
            font-size:0.9rem;
        }
    }
    
    &>.showOnHoverContent{
        z-index:4;
        
        min-width:40rem;
        background-color:var(--extra-extra-light-gray);
        position:absolute;
        box-shadow: var(--on-hover-visible-object-TOPLESS-shadow);
        border-radius: 0 0.5rem 0.5rem 0.5rem;
        &>.contentOfContents{
            visibility: hidden;
            
        }
    }
    ${props => props.$open ? `
    .status{
        background-color:var(--extra-extra-light-gray);
        box-shadow:var(--on-hover-visible-object-shadow);
    }
    &>.showOnHoverContent{
        height:7rem;
        z-index:101;
        &>.contentOfContents{
            transition-property: visibility;
            
            visibility: visible;
        }
    `:`
    &>.showOnHoverContent{
        height:0rem;
    }

    `}
    
`


const customActionTitleGenerator = (type) => {
    switch (type) {
        case "shop":
            return "Shop";
        case "puTrailer":
            return "Trailer PU";
        case "dropTrailer":
            return "Trailer DROP";
        case "swapTrailer":
            return "Swap Trailers";
        case "yard":
            return "Yard";
        case "park":
            return "Relocating";
        case "homeTime":
            return "Home Time";
        case "reset":
            return "Reset";
        case "custom":
            return "Custom Task";
        default:
    }
}

export const MB_STATUS = ({status, tasks, truckId, popupViewManagingObject}) => {
    const [open, setOpen] = useState(false);
    const container = useRef(null);
    // closePopupsViews["taskListClose"] = ()=>{
    //     setOpen(undefined);
    //     setTimeout(() => {
    //         setOpen(false);
    //     }, 300);
    // };
    
    
    return <StatusContainer $colorcode={status.colorCode} $open={open} ref={container} >  
        <div className="status">
            <div onClick={(e)=>{
                e.stopPropagation();
                popupViewManagingObject(truckId+"status", container, setOpen);
                setOpen(true);
            }} >
                {status.textVal}
            </div>
        </div>
        <div className="showOnHoverContent" >
            <div className="contentOfContents">
            {open ? <>
                    <DiagramView taskList={tasks} setTasks={()=>{}} truckId={truckId} backgroundColor={'var(--extra-extra-light-gray)'} showTooltip={true} />
                    </>: null
            }</div>
        </div>
    </StatusContainer>
}

export const statusCodeGenerator = (tasks) => {
    let currentStatus = "Ready";
    let colorCode = "var(--lightAlertRGB)"; //light alert
    if(tasks && tasks.length > 0){
        const firstTask = tasks[0];
        const loadStopIndex = firstTask.loadId ? firstTask.loadStopIndex : null;
        const firstActionOfFirstTask = firstTask.actions[0];
        if(firstActionOfFirstTask.loadAction){
            if(firstTask.onSite){
                currentStatus = `On-Site (${firstActionOfFirstTask.type})`;
                colorCode = "var(--inProgressYellowRGB)";
            }else{
                if(loadStopIndex === 0){ // FIRST STOP OF THE LOAD
                    currentStatus = firstActionOfFirstTask.dispatched ? "Dispatched" : "Not Dispatched";
                    colorCode = currentStatus === "Dispatched" ? "var(--inProgressBlueRGB)" : "var(--lightAlertRGB)";
                }else{
                    currentStatus = "Covered";
                    colorCode = "var(--inProgressGreenRGB)";
                    // colorCode = "var(--successGreenRGB)";
                }
            }
        }else{
            currentStatus = `${customActionTitleGenerator(firstActionOfFirstTask.type)}`;
            if(firstTask.onSite){   
                
                             
                if(firstActionOfFirstTask.type === "homeTime" || firstActionOfFirstTask.type === "custom" || firstActionOfFirstTask.type === "reset"){
                    colorCode = "var(--inProgressPurpleRGB)";
                }else{
                    colorCode = "var(--inProgressYellowRGB)";
                }
            }else{
                colorCode = firstActionOfFirstTask.dispatchingRequired && !firstActionOfFirstTask.dispatched ? "var(--lightAlertRGB)" : "var(--inProgressBlueRGB)";
            }
        }
    }
    
    return {textVal: currentStatus, colorCode: colorCode};
}